import { api } from "./index";

type OrderLookupParams = {
  shipInsureId?: string;
  orderNumber?: string;
  email?: string;
};

export const getOrderLookup = ({
  shipInsureId,
  orderNumber,
  email,
}: OrderLookupParams) => {
  return api.get("/webapp/order_lookup", {
    params: {
      ship_insure_id: shipInsureId,
      order_number: orderNumber,
      email_address: email,
    },
  });
};
